import base from './base'
import handleErrors from './handleErrors'
export default {
    get: (resource, params, errMsg = null) =>
        ({
            ...base,
        }
            .get(resource, params)
            .catch((err) => handleErrors(err, errMsg))),
    post: (resource, payload, config = null) =>
        ({
            ...base,
        }
            .post(resource, payload, config)
            .catch(handleErrors)),
    put: (resource, payload) =>
        ({
            ...base,
        }
            .put(resource, payload)
            .catch(handleErrors)),
    delete: (resource, payload) =>
        ({
            ...base,
        }
            .delete(resource, payload)
            .catch(handleErrors)),
}
